import type { IDataState } from "@/store/modules/data";
import { DataModules } from "@/store/modules/data/modules";
import type { ApiPathGetter } from "@upmind-automation/types";
import type { ActionTree, GetterTree } from "vuex";
import type { IState } from "@/store";

const initialState = {} as IDataState;

const getters: GetterTree<IDataState, IState> = {
  apiPath: (): ApiPathGetter => () => {
    const admin = `api/admin/auth_providers`;
    return { admin };
  },
  scope: () => {
    return `$auth_providers`;
  },
  providerFieldsScope: (): ApiPathGetter => providerId => {
    return `$auth_provider_${providerId}_fields`;
  }
};

const actions: ActionTree<IDataState, IState> = {
  list: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/list",
      {
        ...payload,
        path: getters.apiPath().admin,
        storeModule: DataModules.AUTH_PROVIDERS
      },
      { root: true }
    );
  },
  getProviderFields: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/get",
      {
        ...payload,
        path: `${getters.apiPath().admin}/${payload.providerId}/fields`,
        storeModule: DataModules.AUTH_PROVIDERS
      },
      { root: true }
    );
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions
};
